var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowItWorksBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2131.039,
    height: 1178.879,
    viewBox: "0 0 2131.039 1178.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.097,
    y1: 0.096,
    x2: 0.723,
    y2: 0.955,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0455b7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#0050b0",
    stopOpacity: 0.278
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#0050b0",
    stopOpacity: 0.749
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#166ace",
    stopOpacity: 0.349
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.028,
    y1: 0.122,
    x2: 0.748,
    y2: 0.946,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef6004",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#ef6004",
    stopOpacity: 0.459
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ef6004",
    stopOpacity: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6004",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.338,
    cy: 0.295,
    r: 0.524,
    gradientTransform: "matrix(0.776, 0.631, -0.582, 0.716, 0.247, -0.13)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefaf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#f27f35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6004"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.284,
    cy: 0.239,
    r: 0.439,
    gradientTransform: "matrix(0.163, 0.987, -0.91, 0.15, 0.455, -0.078)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#fef0e8",
    stopOpacity: 0.749
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6004",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.358,
    cy: 0.325,
    r: 0.471,
    gradientTransform: "matrix(0.779, 0.627, -0.617, 0.766, 0.28, -0.149)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefaf8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6004",
    stopOpacity: 0.702
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.338,
    cy: 0.295,
    r: 0.524,
    gradientTransform: "matrix(0.776, 0.631, -0.582, 0.716, 0.247, -0.13)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefaf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#0050b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050b0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.284,
    cy: 0.239,
    r: 0.439,
    gradientTransform: "matrix(0.163, 0.987, -0.91, 0.15, 0.455, -0.078)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#b6d4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cde1fa"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.358,
    cy: 0.325,
    r: 0.471,
    gradientTransform: "matrix(0.779, 0.627, -0.617, 0.766, 0.28, -0.149)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#3c78c1",
    stopOpacity: 0.749
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050b0",
    stopOpacity: 0.749
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.097,
    y1: 0.904,
    x2: 0.277,
    y2: 0.045,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.028,
    y1: 0.878,
    x2: 0.252,
    y2: 0.054,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 0.338,
    cy: 0.295,
    r: 0.524,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 0.284,
    cy: 0.239,
    r: 0.439,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 0.358,
    cy: 0.325,
    r: 0.471,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 0.338,
    cy: 0.295,
    r: 0.524,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 0.284,
    cy: 0.239,
    r: 0.439,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 0.358,
    cy: 0.325,
    r: 0.471,
    xlinkHref: "#radial-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphics",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21219",
    "data-name": "Path 21219",
    d: "M-10547.844,171.809l8.72-5.813a.1.1,0,0,0,0-.164l-8.72-5.813a.1.1,0,0,0-.156.082v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10547.844,171.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.164l-8.72-5.813a.1.1,0,0,0-.156.082v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10518.844,171.809Zm29,0,8.718-5.813a.1.1,0,0,0,0-.164l-8.718-5.813a.1.1,0,0,0-.156.082v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10489.843,171.809Zm29,0,8.718-5.813a.1.1,0,0,0,0-.164l-8.718-5.813a.1.1,0,0,0-.156.082v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10460.843,171.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.164l-8.72-5.813a.1.1,0,0,0-.153.082v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10431.845,171.809Zm29,0,8.721-5.813a.1.1,0,0,0,0-.164l-8.721-5.813a.1.1,0,0,0-.153.082v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10402.845,171.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.164l-8.72-5.813a.1.1,0,0,0-.153.082v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10373.844,171.809Zm-174-32,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.156.085v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10547.844,139.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.156.085v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10518.844,139.809Zm29,0,8.718-5.813a.1.1,0,0,0,0-.167l-8.718-5.813a.1.1,0,0,0-.156.085v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10489.843,139.809Zm29,0,8.718-5.813a.1.1,0,0,0,0-.167l-8.718-5.813a.1.1,0,0,0-.156.085v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10460.843,139.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.153.085v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10431.845,139.809Zm29,0,8.721-5.813a.1.1,0,0,0,0-.167l-8.721-5.813a.1.1,0,0,0-.153.085v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10402.845,139.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.153.085v11.627a.1.1,0,0,0,.1.1A.1.1,0,0,0-10373.844,139.809Zm-174-32,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.156.085v11.624a.1.1,0,0,0,.1.1A.1.1,0,0,0-10547.844,107.81Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.156.085v11.624a.1.1,0,0,0,.1.1A.1.1,0,0,0-10518.844,107.81Zm29,0,8.718-5.813a.1.1,0,0,0,0-.167l-8.718-5.813a.1.1,0,0,0-.156.085v11.624a.1.1,0,0,0,.1.1A.1.1,0,0,0-10489.843,107.81Zm29,0,8.718-5.813a.1.1,0,0,0,0-.167l-8.718-5.813a.1.1,0,0,0-.156.085v11.624a.1.1,0,0,0,.1.1A.1.1,0,0,0-10460.843,107.81Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.153.085v11.624a.1.1,0,0,0,.1.1A.1.1,0,0,0-10431.845,107.81Zm29,0,8.721-5.813a.1.1,0,0,0,0-.167l-8.721-5.813a.1.1,0,0,0-.153.085v11.624a.1.1,0,0,0,.1.1A.1.1,0,0,0-10402.845,107.81Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.153.085v11.624a.1.1,0,0,0,.1.1A.1.1,0,0,0-10373.844,107.81Zm-174-32,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.156.082V75.726a.1.1,0,0,0,.1.1A.1.1,0,0,0-10547.844,75.811Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.156.082V75.726a.1.1,0,0,0,.1.1A.1.1,0,0,0-10518.844,75.811Zm29,0,8.718-5.813a.1.1,0,0,0,0-.167l-8.718-5.813a.1.1,0,0,0-.156.082V75.726a.1.1,0,0,0,.1.1A.1.1,0,0,0-10489.843,75.811Zm29,0,8.718-5.813a.1.1,0,0,0,0-.167l-8.718-5.813a.1.1,0,0,0-.156.082V75.726a.1.1,0,0,0,.1.1A.1.1,0,0,0-10460.843,75.811Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.153.082V75.726a.1.1,0,0,0,.1.1A.1.1,0,0,0-10431.845,75.811Zm29,0,8.721-5.813a.1.1,0,0,0,0-.167l-8.721-5.813a.1.1,0,0,0-.153.082V75.726a.1.1,0,0,0,.1.1A.1.1,0,0,0-10402.845,75.811Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813a.1.1,0,0,0-.153.082V75.726a.1.1,0,0,0,.1.1A.1.1,0,0,0-10373.844,75.811Zm-174-32,8.72-5.813a.1.1,0,0,0,0-.164l-8.72-5.813a.1.1,0,0,0-.156.082V43.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10547.844,43.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.164l-8.72-5.813a.1.1,0,0,0-.156.082V43.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10518.844,43.809Zm29,0,8.718-5.813a.1.1,0,0,0,0-.164l-8.718-5.813a.1.1,0,0,0-.156.082V43.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10489.843,43.809Zm29,0,8.718-5.813a.1.1,0,0,0,0-.164l-8.718-5.813a.1.1,0,0,0-.156.082V43.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10460.843,43.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.164l-8.72-5.813a.1.1,0,0,0-.153.082V43.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10431.845,43.809Zm29,0,8.721-5.813a.1.1,0,0,0,0-.164l-8.721-5.813a.1.1,0,0,0-.153.082V43.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10402.845,43.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.164l-8.72-5.813a.1.1,0,0,0-.153.082V43.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10373.844,43.809Zm-174-32,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813A.1.1,0,0,0-10548,.1V11.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10547.844,11.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813A.1.1,0,0,0-10519,.1V11.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10518.844,11.809Zm29,0,8.718-5.813a.1.1,0,0,0,0-.167l-8.718-5.813A.1.1,0,0,0-10490,.1V11.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10489.843,11.809Zm29,0,8.718-5.813a.1.1,0,0,0,0-.167l-8.718-5.813A.1.1,0,0,0-10461,.1V11.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10460.843,11.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813A.1.1,0,0,0-10432,.1V11.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10431.845,11.809Zm29,0,8.721-5.813a.1.1,0,0,0,0-.167l-8.721-5.813A.1.1,0,0,0-10403,.1V11.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10402.845,11.809Zm29,0,8.72-5.813a.1.1,0,0,0,0-.167l-8.72-5.813A.1.1,0,0,0-10374,.1V11.727a.1.1,0,0,0,.1.1A.1.1,0,0,0-10373.844,11.809Z",
    transform: "translate(10914.728 268.213)",
    fill: "#ef6004",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21220",
    "data-name": "Path 21220",
    d: "M-10413.073,115.651a3.213,3.213,0,0,1,3.212-3.212,3.214,3.214,0,0,1,3.213,3.212,3.213,3.213,0,0,1-3.213,3.212A3.211,3.211,0,0,1-10413.073,115.651Zm-22.489,0a3.214,3.214,0,0,1,3.213-3.212,3.213,3.213,0,0,1,3.213,3.212,3.212,3.212,0,0,1-3.213,3.212A3.213,3.213,0,0,1-10435.562,115.651Zm-22.486,0a3.213,3.213,0,0,1,3.212-3.212,3.213,3.213,0,0,1,3.213,3.212,3.212,3.212,0,0,1-3.213,3.212A3.212,3.212,0,0,1-10458.049,115.651Zm-22.488,0a3.213,3.213,0,0,1,3.213-3.212,3.213,3.213,0,0,1,3.212,3.212,3.212,3.212,0,0,1-3.212,3.212A3.211,3.211,0,0,1-10480.537,115.651Zm-22.486,0a3.211,3.211,0,0,1,3.212-3.212,3.213,3.213,0,0,1,3.212,3.212,3.212,3.212,0,0,1-3.212,3.212A3.21,3.21,0,0,1-10503.023,115.651Zm-22.489,0a3.213,3.213,0,0,1,3.212-3.212,3.214,3.214,0,0,1,3.214,3.212,3.213,3.213,0,0,1-3.214,3.212A3.212,3.212,0,0,1-10525.513,115.651Zm-22.488,0a3.215,3.215,0,0,1,3.213-3.212,3.212,3.212,0,0,1,3.212,3.212,3.211,3.211,0,0,1-3.212,3.212A3.213,3.213,0,0,1-10548,115.651Zm134.928-22.487a3.211,3.211,0,0,1,3.212-3.212,3.213,3.213,0,0,1,3.213,3.212,3.214,3.214,0,0,1-3.213,3.212A3.213,3.213,0,0,1-10413.073,93.163Zm-22.489,0a3.213,3.213,0,0,1,3.213-3.212,3.212,3.212,0,0,1,3.213,3.212,3.213,3.213,0,0,1-3.213,3.212A3.214,3.214,0,0,1-10435.562,93.163Zm-22.486,0a3.212,3.212,0,0,1,3.212-3.212,3.212,3.212,0,0,1,3.213,3.212,3.213,3.213,0,0,1-3.213,3.212A3.213,3.213,0,0,1-10458.049,93.163Zm-22.488,0a3.211,3.211,0,0,1,3.213-3.212,3.212,3.212,0,0,1,3.212,3.212,3.213,3.213,0,0,1-3.212,3.212A3.213,3.213,0,0,1-10480.537,93.163Zm-22.486,0a3.21,3.21,0,0,1,3.212-3.212,3.212,3.212,0,0,1,3.212,3.212,3.213,3.213,0,0,1-3.212,3.212A3.211,3.211,0,0,1-10503.023,93.163Zm-22.489,0a3.212,3.212,0,0,1,3.212-3.212,3.213,3.213,0,0,1,3.214,3.212,3.214,3.214,0,0,1-3.214,3.212A3.213,3.213,0,0,1-10525.513,93.163Zm-22.488,0a3.213,3.213,0,0,1,3.213-3.212,3.211,3.211,0,0,1,3.212,3.212,3.212,3.212,0,0,1-3.212,3.212A3.215,3.215,0,0,1-10548,93.163Zm134.928-22.487a3.211,3.211,0,0,1,3.212-3.212,3.213,3.213,0,0,1,3.213,3.212,3.214,3.214,0,0,1-3.213,3.212A3.213,3.213,0,0,1-10413.073,70.676Zm-22.489,0a3.213,3.213,0,0,1,3.213-3.212,3.212,3.212,0,0,1,3.213,3.212,3.213,3.213,0,0,1-3.213,3.212A3.214,3.214,0,0,1-10435.562,70.676Zm-22.486,0a3.212,3.212,0,0,1,3.212-3.212,3.212,3.212,0,0,1,3.213,3.212,3.213,3.213,0,0,1-3.213,3.212A3.213,3.213,0,0,1-10458.049,70.676Zm-22.488,0a3.211,3.211,0,0,1,3.213-3.212,3.212,3.212,0,0,1,3.212,3.212,3.213,3.213,0,0,1-3.212,3.212A3.213,3.213,0,0,1-10480.537,70.676Zm-22.486,0a3.21,3.21,0,0,1,3.212-3.212,3.212,3.212,0,0,1,3.212,3.212,3.213,3.213,0,0,1-3.212,3.212A3.211,3.211,0,0,1-10503.023,70.676Zm-22.489,0a3.212,3.212,0,0,1,3.212-3.212,3.213,3.213,0,0,1,3.214,3.212,3.214,3.214,0,0,1-3.214,3.212A3.213,3.213,0,0,1-10525.513,70.676Zm-22.488,0a3.213,3.213,0,0,1,3.213-3.212,3.211,3.211,0,0,1,3.212,3.212,3.212,3.212,0,0,1-3.212,3.212A3.215,3.215,0,0,1-10548,70.676Zm134.928-22.489a3.213,3.213,0,0,1,3.212-3.212,3.214,3.214,0,0,1,3.213,3.212,3.213,3.213,0,0,1-3.213,3.212A3.211,3.211,0,0,1-10413.073,48.187Zm-22.489,0a3.214,3.214,0,0,1,3.213-3.212,3.213,3.213,0,0,1,3.213,3.212,3.212,3.212,0,0,1-3.213,3.212A3.213,3.213,0,0,1-10435.562,48.187Zm-22.486,0a3.213,3.213,0,0,1,3.212-3.212,3.213,3.213,0,0,1,3.213,3.212,3.212,3.212,0,0,1-3.213,3.212A3.212,3.212,0,0,1-10458.049,48.187Zm-22.488,0a3.213,3.213,0,0,1,3.213-3.212,3.213,3.213,0,0,1,3.212,3.212,3.212,3.212,0,0,1-3.212,3.212A3.211,3.211,0,0,1-10480.537,48.187Zm-22.486,0a3.211,3.211,0,0,1,3.212-3.212,3.213,3.213,0,0,1,3.212,3.212,3.212,3.212,0,0,1-3.212,3.212A3.21,3.21,0,0,1-10503.023,48.187Zm-22.489,0a3.213,3.213,0,0,1,3.212-3.212,3.214,3.214,0,0,1,3.214,3.212,3.213,3.213,0,0,1-3.214,3.212A3.212,3.212,0,0,1-10525.513,48.187Zm-22.488,0a3.215,3.215,0,0,1,3.213-3.212,3.212,3.212,0,0,1,3.212,3.212,3.211,3.211,0,0,1-3.212,3.212A3.213,3.213,0,0,1-10548,48.187Zm134.928-22.487a3.213,3.213,0,0,1,3.212-3.212,3.214,3.214,0,0,1,3.213,3.212,3.213,3.213,0,0,1-3.213,3.212A3.211,3.211,0,0,1-10413.073,25.7Zm-22.489,0a3.214,3.214,0,0,1,3.213-3.212,3.213,3.213,0,0,1,3.213,3.212,3.212,3.212,0,0,1-3.213,3.212A3.213,3.213,0,0,1-10435.562,25.7Zm-22.486,0a3.213,3.213,0,0,1,3.212-3.212,3.213,3.213,0,0,1,3.213,3.212,3.212,3.212,0,0,1-3.213,3.212A3.212,3.212,0,0,1-10458.049,25.7Zm-22.488,0a3.213,3.213,0,0,1,3.213-3.212,3.213,3.213,0,0,1,3.212,3.212,3.212,3.212,0,0,1-3.212,3.212A3.211,3.211,0,0,1-10480.537,25.7Zm-22.486,0a3.211,3.211,0,0,1,3.212-3.212,3.213,3.213,0,0,1,3.212,3.212,3.212,3.212,0,0,1-3.212,3.212A3.21,3.21,0,0,1-10503.023,25.7Zm-22.489,0a3.213,3.213,0,0,1,3.212-3.212,3.214,3.214,0,0,1,3.214,3.212,3.213,3.213,0,0,1-3.214,3.212A3.212,3.212,0,0,1-10525.513,25.7Zm-22.488,0a3.215,3.215,0,0,1,3.213-3.212,3.212,3.212,0,0,1,3.212,3.212,3.211,3.211,0,0,1-3.212,3.212A3.213,3.213,0,0,1-10548,25.7Zm134.928-22.487A3.213,3.213,0,0,1-10409.861,0a3.214,3.214,0,0,1,3.213,3.212,3.213,3.213,0,0,1-3.213,3.212A3.211,3.211,0,0,1-10413.073,3.212Zm-22.489,0A3.214,3.214,0,0,1-10432.35,0a3.213,3.213,0,0,1,3.213,3.212,3.212,3.212,0,0,1-3.213,3.212A3.213,3.213,0,0,1-10435.562,3.212Zm-22.486,0A3.213,3.213,0,0,1-10454.837,0a3.213,3.213,0,0,1,3.213,3.212,3.212,3.212,0,0,1-3.213,3.212A3.212,3.212,0,0,1-10458.049,3.212Zm-22.488,0A3.213,3.213,0,0,1-10477.324,0a3.213,3.213,0,0,1,3.212,3.212,3.212,3.212,0,0,1-3.212,3.212A3.211,3.211,0,0,1-10480.537,3.212Zm-22.486,0A3.211,3.211,0,0,1-10499.812,0a3.213,3.213,0,0,1,3.212,3.212,3.212,3.212,0,0,1-3.212,3.212A3.21,3.21,0,0,1-10503.023,3.212Zm-22.489,0A3.213,3.213,0,0,1-10522.3,0a3.214,3.214,0,0,1,3.214,3.212,3.213,3.213,0,0,1-3.214,3.212A3.212,3.212,0,0,1-10525.513,3.212Zm-22.488,0A3.215,3.215,0,0,1-10544.788,0a3.212,3.212,0,0,1,3.212,3.212,3.211,3.211,0,0,1-3.212,3.212A3.213,3.213,0,0,1-10548,3.212Z",
    transform: "translate(10817.148 831.172)",
    fill: "#0050b0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellipse",
    transform: "translate(150.847 287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861",
    transform: "translate(966.934 -287)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20251",
    "data-name": "Path 20251",
    d: "M18868.623-2737.747a514.679,514.679,0,0,1-51.8-2.615,507.618,507.618,0,0,1-50.3-7.677c-16.322-3.341-32.656-7.541-48.549-12.484-15.717-4.889-31.383-10.621-46.551-17.037-15.029-6.356-29.928-13.534-44.287-21.334-14.258-7.743-28.309-16.281-41.77-25.377-13.4-9.05-26.521-18.862-39-29.165-12.457-10.278-24.557-21.279-35.98-32.7s-22.424-23.529-32.7-35.977c-10.3-12.487-20.115-25.609-29.158-39-9.1-13.472-17.645-27.526-25.385-41.771-7.791-14.349-14.969-29.249-21.33-44.286-6.42-15.166-12.148-30.826-17.037-46.547-4.949-15.9-9.148-32.238-12.48-48.552a506.623,506.623,0,0,1-7.68-50.3,514.309,514.309,0,0,1-2.619-51.8,514.322,514.322,0,0,1,2.619-51.8,506.572,506.572,0,0,1,7.68-50.3c3.332-16.314,7.531-32.649,12.48-48.552,4.889-15.721,10.623-31.382,17.037-46.547,6.361-15.037,13.531-29.937,21.33-44.287,7.74-14.244,16.281-28.3,25.385-41.771,9.043-13.4,18.859-26.517,29.158-39,10.271-12.449,21.277-24.554,32.7-35.977s23.523-22.421,35.98-32.7c12.482-10.3,25.607-20.115,39-29.165,13.461-9.095,27.512-17.633,41.77-25.376,14.363-7.8,29.266-14.978,44.287-21.334,15.168-6.416,30.834-12.148,46.551-17.036,15.893-4.944,32.227-9.144,48.549-12.484a508.075,508.075,0,0,1,50.3-7.677,514.967,514.967,0,0,1,51.8-2.616,515.063,515.063,0,0,1,51.8,2.616,507.86,507.86,0,0,1,50.3,7.677c16.326,3.34,32.658,7.54,48.547,12.484,15.719,4.888,31.385,10.62,46.553,17.036,15.025,6.356,29.924,13.534,44.285,21.334,14.26,7.745,28.311,16.283,41.771,25.376,13.393,9.05,26.521,18.862,39,29.165,12.451,10.275,24.557,21.277,35.975,32.7s22.424,23.52,32.7,35.977c10.3,12.478,20.111,25.6,29.166,39,9.092,13.457,17.629,27.511,25.379,41.771,7.807,14.367,14.984,29.268,21.33,44.287,6.414,15.165,12.146,30.825,17.037,46.547,4.941,15.9,9.152,32.238,12.486,48.552a507.131,507.131,0,0,1,7.674,50.3,515.747,515.747,0,0,1,2.619,51.8,515.727,515.727,0,0,1-2.619,51.8,507.094,507.094,0,0,1-7.674,50.3c-3.34,16.314-7.545,32.65-12.486,48.552-4.891,15.72-10.623,31.381-17.037,46.547-6.346,15.02-13.527,29.919-21.33,44.286-7.75,14.261-16.287,28.315-25.379,41.771-9.055,13.4-18.865,26.523-29.166,39-10.275,12.456-21.273,24.561-32.7,35.977s-23.523,22.423-35.975,32.7c-12.48,10.3-25.609,20.115-39,29.165-13.461,9.094-27.512,17.632-41.771,25.377-14.361,7.8-29.26,14.978-44.285,21.334-15.168,6.416-30.834,12.147-46.553,17.037-15.889,4.943-32.221,9.144-48.547,12.484a508.147,508.147,0,0,1-50.3,7.677A514.659,514.659,0,0,1,18868.623-2737.747Zm0-1011.668c-278.48,0-505.039,226.562-505.039,505.043s226.559,505.044,505.039,505.044,505.045-226.562,505.045-505.044S19147.107-3749.415,18868.623-3749.415Z",
    transform: "translate(-18361.996 3751)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20252",
    "data-name": "Path 20252",
    d: "M18753.656-2967.693a397.886,397.886,0,0,1-40.049-2.022,392.645,392.645,0,0,1-38.883-5.935c-12.623-2.582-25.25-5.829-37.539-9.65-12.148-3.78-24.256-8.211-35.98-13.17-11.623-4.914-23.139-10.463-34.238-16.493-11.023-5.986-21.887-12.586-32.291-19.618-10.357-7-20.5-14.582-30.15-22.547-9.631-7.945-18.986-16.449-27.814-25.277s-17.334-18.189-25.279-27.812c-7.961-9.653-15.551-19.8-22.545-30.151-7.033-10.414-13.635-21.279-19.615-32.291-6.029-11.093-11.582-22.612-16.494-34.236-4.957-11.724-9.393-23.83-13.174-35.983-3.818-12.293-7.068-24.922-9.646-37.533a392.553,392.553,0,0,1-5.941-38.887,398.758,398.758,0,0,1-2.018-40.044,398.8,398.8,0,0,1,2.018-40.045,392.534,392.534,0,0,1,5.941-38.888c2.578-12.611,5.828-25.239,9.646-37.534,3.781-12.153,8.219-24.26,13.174-35.983,4.912-11.625,10.465-23.143,16.494-34.237,5.98-11.012,12.582-21.876,19.615-32.292,6.994-10.355,14.584-20.5,22.545-30.151,7.945-9.624,16.447-18.981,25.279-27.813s18.184-17.333,27.814-25.279c9.648-7.964,19.793-15.55,30.15-22.546,10.4-7.031,21.268-13.631,32.291-19.617,11.1-6.03,22.615-11.579,34.238-16.492,11.729-4.959,23.832-9.391,35.98-13.17,12.289-3.822,24.916-7.069,37.539-9.651a392.3,392.3,0,0,1,38.883-5.935,398.075,398.075,0,0,1,40.049-2.022,398.075,398.075,0,0,1,40.043,2.022,392.592,392.592,0,0,1,38.889,5.935c12.617,2.582,25.244,5.829,37.531,9.651,12.148,3.779,24.26,8.21,35.986,13.17,11.615,4.913,23.133,10.462,34.234,16.492,11.021,5.988,21.883,12.588,32.291,19.617,10.355,7,20.5,14.582,30.148,22.546,9.627,7.944,18.99,16.449,27.818,25.279s17.328,18.183,25.275,27.813c7.963,9.646,15.545,19.79,22.543,30.151,7.031,10.4,13.637,21.268,19.621,32.292,6.033,11.107,11.578,22.625,16.492,34.237,4.957,11.724,9.393,23.83,13.17,35.983,3.826,12.295,7.07,24.923,9.652,37.534a393.09,393.09,0,0,1,5.934,38.888,397.973,397.973,0,0,1,2.023,40.045,397.951,397.951,0,0,1-2.023,40.044,393.054,393.054,0,0,1-5.934,38.887c-2.582,12.612-5.826,25.24-9.652,37.533-3.777,12.153-8.213,24.259-13.17,35.983-4.914,11.611-10.459,23.13-16.492,34.236-5.992,11.024-12.59,21.889-19.621,32.291-7,10.36-14.58,20.5-22.543,30.151-7.947,9.629-16.453,18.987-25.275,27.813s-18.191,17.335-27.818,25.277c-9.646,7.965-19.793,15.551-30.148,22.547-10.408,7.03-21.27,13.63-32.291,19.618-11.1,6.03-22.619,11.579-34.234,16.493-11.727,4.96-23.838,9.39-35.986,13.17-12.287,3.821-24.914,7.069-37.531,9.65a393.1,393.1,0,0,1-38.889,5.935A397.915,397.915,0,0,1,18753.656-2967.693Zm0-782.081c-215.285,0-390.434,175.146-390.434,390.429s175.148,390.43,390.434,390.43,390.428-175.146,390.428-390.43S18968.941-3749.774,18753.656-3749.774Z",
    transform: "translate(-18247.027 3865.973)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862",
    transform: "translate(955.301 16.261)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "ellipse-2",
    "data-name": "ellipse",
    transform: "translate(1.319 190.127) rotate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M12.539,0A12.539,12.539,0,1,1,0,12.539,12.539,12.539,0,0,1,12.539,0Z",
    transform: "translate(0 0.116)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M12.539,0A12.539,12.539,0,1,1,0,12.539,12.539,12.539,0,0,1,12.539,0Z",
    transform: "translate(0.069 0)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M12.539,0A12.539,12.539,0,1,1,0,12.539,12.539,12.539,0,0,1,12.539,0Z",
    transform: "translate(0 0.116)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M12.539,0A12.539,12.539,0,1,1,0,12.539,12.539,12.539,0,0,1,12.539,0Z",
    transform: "translate(0 0.116)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellipse-3",
    "data-name": "ellipse",
    transform: "translate(194.234 588.686) rotate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M7.822,0A7.822,7.822,0,1,1,0,7.822,7.822,7.822,0,0,1,7.822,0Z",
    transform: "translate(0 0.072)",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-2",
    "data-name": "Path 25",
    d: "M7.822,0A7.822,7.822,0,1,1,0,7.822,7.822,7.822,0,0,1,7.822,0Z",
    transform: "translate(0.043 0)",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M7.822,0A7.822,7.822,0,1,1,0,7.822,7.822,7.822,0,0,1,7.822,0Z",
    transform: "translate(0 0.072)",
    fill: "url(#radial-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellipse-4",
    "data-name": "ellipse",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 382.248, 567.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-3",
    "data-name": "Path 29",
    d: "M10.776,0A10.776,10.776,0,1,1,0,10.776,10.776,10.776,0,0,1,10.776,0Z",
    transform: "translate(0 0.099)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-3",
    "data-name": "Path 25",
    d: "M10.776,0A10.776,10.776,0,1,1,0,10.776,10.776,10.776,0,0,1,10.776,0Z",
    transform: "translate(0.06 0)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-3",
    "data-name": "Path 30",
    d: "M10.776,0A10.776,10.776,0,1,1,0,10.776,10.776,10.776,0,0,1,10.776,0Z",
    transform: "translate(0 0.099)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-2",
    "data-name": "Path 28",
    d: "M10.776,0A10.776,10.776,0,1,1,0,10.776,10.776,10.776,0,0,1,10.776,0Z",
    transform: "translate(0 0.099)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellipse-5",
    "data-name": "ellipse",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 40.268, 4.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-4",
    "data-name": "Path 29",
    d: "M8.249,0A8.249,8.249,0,1,1,0,8.249,8.249,8.249,0,0,1,8.249,0Z",
    transform: "translate(0 0.076)",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-4",
    "data-name": "Path 25",
    d: "M8.249,0A8.249,8.249,0,1,1,0,8.249,8.249,8.249,0,0,1,8.249,0Z",
    transform: "translate(0.046 0)",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-4",
    "data-name": "Path 30",
    d: "M8.249,0A8.249,8.249,0,1,1,0,8.249,8.249,8.249,0,0,1,8.249,0Z",
    transform: "translate(0 0.076)",
    fill: "url(#radial-gradient-6)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ellipse-6",
    "data-name": "ellipse",
    transform: "translate(0 602.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_861-2",
    "data-name": "Group 861",
    transform: "translate(0 0)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20251-2",
    "data-name": "Path 20251",
    d: "M18650.273-3751a292.888,292.888,0,0,1,29.477,1.488,288.9,288.9,0,0,1,28.621,4.368c9.287,1.9,18.582,4.291,27.625,7.1,8.941,2.782,17.859,6.043,26.484,9.694,8.555,3.616,17.033,7.7,25.205,12.139,8.109,4.406,16.107,9.264,23.764,14.44,7.625,5.149,15.092,10.732,22.2,16.595s13.971,12.108,20.473,18.606,12.76,13.388,18.605,20.471c5.863,7.1,11.443,14.571,16.592,22.193,5.178,7.666,10.037,15.663,14.443,23.768,4.432,8.165,8.518,16.643,12.137,25.2,3.652,8.629,6.91,17.541,9.693,26.486,2.818,9.048,5.2,18.343,7.1,27.626a288.049,288.049,0,0,1,4.371,28.623,292.307,292.307,0,0,1,1.49,29.474,292.318,292.318,0,0,1-1.49,29.475,288.032,288.032,0,0,1-4.371,28.623c-1.9,9.283-4.283,18.578-7.1,27.627-2.783,8.945-6.043,17.856-9.693,26.485-3.619,8.556-7.7,17.034-12.137,25.2-4.406,8.105-9.266,16.1-14.443,23.768-5.148,7.622-10.732,15.089-16.592,22.193-5.846,7.084-12.107,13.972-18.605,20.472s-13.383,12.758-20.473,18.606-14.57,11.446-22.2,16.6c-7.656,5.175-15.654,10.034-23.764,14.439-8.174,4.438-16.652,8.523-25.205,12.139-8.625,3.651-17.543,6.912-26.484,9.694-9.043,2.813-18.338,5.2-27.625,7.1a289.239,289.239,0,0,1-28.621,4.368,293.1,293.1,0,0,1-29.477,1.488,293.075,293.075,0,0,1-29.477-1.488,288.925,288.925,0,0,1-28.623-4.368c-9.289-1.9-18.582-4.291-27.623-7.1-8.945-2.781-17.857-6.043-26.488-9.694-8.551-3.617-17.029-7.7-25.2-12.139-8.115-4.407-16.111-9.265-23.77-14.439-7.619-5.15-15.092-10.733-22.193-16.6-7.084-5.846-13.973-12.107-20.473-18.606s-12.758-13.383-18.6-20.472c-5.863-7.1-11.443-14.566-16.6-22.193-5.174-7.657-10.029-15.654-14.439-23.768-4.445-8.175-8.525-16.654-12.137-25.2-3.65-8.629-6.912-17.54-9.7-26.485-2.811-9.049-5.205-18.344-7.1-27.627a287.456,287.456,0,0,1-4.369-28.623,293.886,293.886,0,0,1-1.49-29.475,293.857,293.857,0,0,1,1.49-29.474,287.451,287.451,0,0,1,4.369-28.623c1.9-9.283,4.291-18.578,7.1-27.626,2.785-8.946,6.047-17.857,9.7-26.486,3.611-8.546,7.7-17.024,12.137-25.2,4.41-8.115,9.266-16.111,14.439-23.768,5.154-7.626,10.734-15.093,16.6-22.193,5.844-7.088,12.1-13.975,18.6-20.471s13.389-12.76,20.473-18.606c7.1-5.863,14.574-11.446,22.193-16.595,7.658-5.175,15.654-10.032,23.77-14.44,8.17-4.439,16.648-8.523,25.2-12.139,8.631-3.651,17.543-6.912,26.488-9.694,9.041-2.812,18.334-5.2,27.623-7.1a289.141,289.141,0,0,1,28.623-4.368A292.859,292.859,0,0,1,18650.273-3751Zm0,575.65c158.457,0,287.373-128.916,287.373-287.375S18808.73-3750.1,18650.273-3750.1s-287.377,128.916-287.377,287.375S18491.813-3175.35,18650.273-3175.35Z",
    transform: "translate(-18361.994 3750.999)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20252-2",
    "data-name": "Path 20252",
    d: "M18584.854-3751a226.444,226.444,0,0,1,22.787,1.15,223.769,223.769,0,0,1,22.127,3.377c7.18,1.469,14.365,3.316,21.359,5.491,6.91,2.151,13.8,4.671,20.473,7.494,6.613,2.8,13.164,5.954,19.482,9.385,6.27,3.406,12.453,7.162,18.373,11.162,5.893,3.981,11.664,8.3,17.156,12.83s10.8,9.359,15.826,14.383,9.863,10.35,14.385,15.826c4.529,5.492,8.848,11.265,12.826,17.156,4,5.926,7.762,12.108,11.16,18.374,3.434,6.312,6.592,12.866,9.387,19.481,2.82,6.672,5.344,13.56,7.5,20.475,2.172,7,4.021,14.181,5.488,21.357a223.421,223.421,0,0,1,3.381,22.127,227.1,227.1,0,0,1,1.148,22.786,227.1,227.1,0,0,1-1.148,22.785,223.418,223.418,0,0,1-3.381,22.128c-1.467,7.176-3.316,14.362-5.488,21.357-2.154,6.915-4.678,13.8-7.5,20.475-2.795,6.614-5.953,13.168-9.387,19.481-3.4,6.265-7.158,12.448-11.16,18.374-3.979,5.892-8.3,11.664-12.826,17.156-4.521,5.476-9.359,10.8-14.385,15.825s-10.348,9.863-15.826,14.384-11.264,8.848-17.156,12.829c-5.92,4-12.1,7.756-18.373,11.163-6.318,3.431-12.869,6.588-19.482,9.384-6.674,2.822-13.562,5.344-20.473,7.494-6.994,2.175-14.18,4.022-21.359,5.491a223.208,223.208,0,0,1-22.127,3.377,226.5,226.5,0,0,1-22.787,1.151,226.561,226.561,0,0,1-22.787-1.151,223.208,223.208,0,0,1-22.127-3.377c-7.18-1.469-14.363-3.316-21.355-5.491-6.914-2.151-13.8-4.672-20.479-7.494-6.607-2.8-13.16-5.953-19.477-9.384-6.273-3.407-12.453-7.163-18.377-11.163-5.891-3.981-11.664-8.3-17.152-12.829s-10.8-9.36-15.828-14.384-9.859-10.346-14.383-15.825-8.844-11.261-12.828-17.156c-4-5.919-7.76-12.1-11.164-18.374-3.434-6.32-6.59-12.874-9.385-19.481-2.82-6.671-5.348-13.56-7.49-20.475-2.182-7-4.025-14.181-5.494-21.357a222.834,222.834,0,0,1-3.377-22.128,225.232,225.232,0,0,1-1.152-22.785,225.246,225.246,0,0,1,1.152-22.786,222.814,222.814,0,0,1,3.377-22.127,220.508,220.508,0,0,1,5.494-21.357c2.143-6.915,4.67-13.8,7.49-20.475,2.795-6.607,5.951-13.161,9.385-19.481,3.408-6.273,7.164-12.455,11.164-18.374,3.98-5.895,8.3-11.667,12.828-17.156s9.361-10.8,14.383-15.826,10.35-9.863,15.828-14.383,11.262-8.848,17.152-12.83c5.924-4,12.1-7.756,18.377-11.162,6.316-3.431,12.869-6.589,19.477-9.385,6.674-2.822,13.564-5.343,20.479-7.494,6.992-2.175,14.176-4.022,21.355-5.491,7.273-1.488,14.721-2.624,22.127-3.377A226.5,226.5,0,0,1,18584.854-3751Zm0,445.012c122.5,0,222.158-99.66,222.158-222.158s-99.662-222.159-222.158-222.159-222.16,99.659-222.16,222.159S18462.354-3305.987,18584.854-3305.987Z",
    transform: "translate(-18296.576 3816.42)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_862-2",
    "data-name": "Group 862",
    transform: "translate(350.604 59.626)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "ellipse-7",
    "data-name": "ellipse",
    transform: "translate(231.82 236.182) rotate(-177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-5",
    "data-name": "Path 29",
    d: "M7.135,0A7.135,7.135,0,1,1,0,7.135,7.135,7.135,0,0,1,7.135,0Z",
    transform: "translate(0 0.066)",
    fill: "url(#radial-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-5",
    "data-name": "Path 25",
    d: "M7.135,0A7.135,7.135,0,1,1,0,7.135,7.135,7.135,0,0,1,7.135,0Z",
    transform: "translate(0.04 0)",
    fill: "url(#radial-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-5",
    "data-name": "Path 30",
    d: "M7.135,0A7.135,7.135,0,1,1,0,7.135,7.135,7.135,0,0,1,7.135,0Z",
    transform: "translate(0 0.066)",
    fill: "url(#radial-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-3",
    "data-name": "Path 28",
    d: "M7.135,0A7.135,7.135,0,1,1,0,7.135,7.135,7.135,0,0,1,7.135,0Z",
    transform: "translate(0 0.066)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellipse-8",
    "data-name": "ellipse",
    transform: "translate(122.049 9.398) rotate(-177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-6",
    "data-name": "Path 29",
    d: "M4.451,0A4.451,4.451,0,1,1,0,4.451,4.451,4.451,0,0,1,4.451,0Z",
    transform: "translate(0 0.041)",
    fill: "url(#radial-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-6",
    "data-name": "Path 25",
    d: "M4.451,0A4.451,4.451,0,1,1,0,4.451,4.451,4.451,0,0,1,4.451,0Z",
    transform: "translate(0.025 0)",
    fill: "url(#radial-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-6",
    "data-name": "Path 30",
    d: "M4.451,0A4.451,4.451,0,1,1,0,4.451,4.451,4.451,0,0,1,4.451,0Z",
    transform: "translate(0 0.041)",
    fill: "url(#radial-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellipse-9",
    "data-name": "ellipse",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 15.067, 21.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-7",
    "data-name": "Path 29",
    d: "M6.132,0A6.132,6.132,0,1,1,0,6.132,6.132,6.132,0,0,1,6.132,0Z",
    transform: "translate(0 0.057)",
    fill: "url(#radial-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-7",
    "data-name": "Path 25",
    d: "M6.132,0A6.132,6.132,0,1,1,0,6.132,6.132,6.132,0,0,1,6.132,0Z",
    transform: "translate(0.034 0)",
    fill: "url(#radial-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-7",
    "data-name": "Path 30",
    d: "M6.132,0A6.132,6.132,0,1,1,0,6.132,6.132,6.132,0,0,1,6.132,0Z",
    transform: "translate(0 0.057)",
    fill: "url(#radial-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-4",
    "data-name": "Path 28",
    d: "M6.132,0A6.132,6.132,0,1,1,0,6.132,6.132,6.132,0,0,1,6.132,0Z",
    transform: "translate(0 0.057)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellipse-10",
    "data-name": "ellipse",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 209.658, 341.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-8",
    "data-name": "Path 29",
    d: "M4.694,0A4.694,4.694,0,1,1,0,4.694,4.694,4.694,0,0,1,4.694,0Z",
    transform: "translate(0 0.043)",
    fill: "url(#radial-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-8",
    "data-name": "Path 25",
    d: "M4.694,0A4.694,4.694,0,1,1,0,4.694,4.694,4.694,0,0,1,4.694,0Z",
    transform: "translate(0.026 0)",
    fill: "url(#radial-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-8",
    "data-name": "Path 30",
    d: "M4.694,0A4.694,4.694,0,1,1,0,4.694,4.694,4.694,0,0,1,4.694,0Z",
    transform: "translate(0 0.043)",
    fill: "url(#radial-gradient-18)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksBg);
export default __webpack_public_path__ + "static/media/how-it-works-bg.7c7a25fd58bac2f2dcf51d3c3e6b0c5c.svg";
export { ForwardRef as ReactComponent };